
import { Component, input } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { FusionService } from '@shared-angular/services/fusion.service';
import { LanguageService } from '@shared-angular/services/language.service';
import { AdminBackButtonComponent } from "../../../../../../../../shared/components/ai-bot/utils/admin-back-button/admin-back-button.component";
import { FusionCaptivateConfigComponent } from '../fusion-captivate-config/fusion-captivate-config.component';
import { FusionHtmlAsMediaConfigComponent } from '../fusion-html-as-media-config/fusion-html-as-media-config.component';
import { FusionHtmlpageConfigComponent } from '../fusion-htmlpage-config/fusion-htmlpage-config.component';
import { FusionIframelyConfigComponent } from "../fusion-iframely-config/fusion-iframely-config.component";
import { FusionKnowledgeworkerConfigComponent } from '../fusion-knowledgeworker-config/fusion-knowledgeworker-config.component';
import { FusionMiroByTemplateComponent } from "../fusion-miro-by-template/fusion-miro-by-template.component";
import { FusionMiroByUrlComponent } from "../fusion-miro-by-url/fusion-miro-by-url.component";
import { FusionRiseConfigComponent } from "../fusion-rise-config/fusion-rise-config.component";
import { FusionStorylineConfigComponent } from "../fusion-storyline-config/fusion-storyline-config.component";
import { FusionYoutubeConfigComponent } from "../fusion-youtube-config/fusion-youtube-config.component";
import { FusionLxtConfigComponent } from './../fusion-lxt-config/fusion-lxt-config.component';

@Component({
  selector: 'app-fusion-bot-detatail',
  imports: [FusionLxtConfigComponent, FusionKnowledgeworkerConfigComponent, FusionRiseConfigComponent, FusionYoutubeConfigComponent, FusionIframelyConfigComponent, FusionHtmlpageConfigComponent, FusionHtmlAsMediaConfigComponent, AdminBackButtonComponent, FusionStorylineConfigComponent, FusionCaptivateConfigComponent, ButtonModule, FusionMiroByTemplateComponent, FusionMiroByUrlComponent],
  templateUrl: './fusion-bot-detatail.component.html',
  styleUrl: './fusion-bot-detatail.component.scss'
})
export class FusionBotDetatailComponent {
  public readonly hideHeader = input(false);
  constructor(public fusionService: FusionService, public langService: LanguageService) { }
}



